<div fxLayout="row" fxFlex="1 1 auto" class="neq-page-wrapper asi-component asi-table neq-table">
  <p-table [columns]="cols" [value]="currentNutriment?.results || []" [loading]="!currentNutriment?.results"
            styleClass="neq-primeng-table" fxFlex>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngIf="nutrients" style="width: 3em; padding-left: 1rem;" scope="col">
          <div class="header-div">
            <div class="header-element">
              <mat-checkbox
                [disabled]="!canShowCheckboxes"
                (change)="toggleAll($event)"
                [matTooltip]="'msg.user.rawmaterial.values.header.checkbox.std-or-proposed-value' | translate"
              ></mat-checkbox>
            </div>
          </div>
        </th>
        <th *ngFor="let col of columns" scope="col">
          {{col.header | translate}}
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [class.sample-mode]="isSampleMode">
        <td *ngIf="nutrients" style="padding-left: 1rem;">
          <mat-checkbox *ngIf="showStandardOrProposedCheckBox(rowData)"
                        (change)="checkboxEvent(rowData)" [ngClass]="getCheckboxColor(rowData)"
                        [matTooltip]="getRowCheckboxTooltip(rowData)"
                        [(ngModel)]="(getNutrientDataTable(rowData) || {}).selected"></mat-checkbox>
        </td>
        <td *ngFor="let col of columns" [class.analysis-col]="col.field === 'analysis'">
          <!-- Show the unit in italic style -->
          <ng-container *ngIf="col.field === 'unit'">
            <span class="italic">{{rowData[col.field]}}</span>
          </ng-container>

          <ng-container *ngIf="col.field === 'analysis'">
            <neq-select-autocomplete *ngIf="showAnalysisList(rowData)" [forcedLoading]="loadingAnalysis"
              [ngModel]="returnSelectedAnalysis(rowData)" bindLabel="label" [clearable]="false"
              [disabled]="disableAnalysisList(rowData)" [forcedData]="returnAnalysisList(rowData)"
              (change)="onAnalysisChange($event, rowData)" (clear)="onAnalysisClear(rowData)"
            >
            </neq-select-autocomplete>
          </ng-container>

          <!-- Icon to be shown on the column nutrient of the raw material value table -->
          <ng-container *ngIf="col.field === 'label' && nutrients">
            <ng-container *ngIf="rowData.technicalDocAvailable" >
              <a (click)="getNutrientTechnicalDocUrl(rowData)"
                  [matTooltip]="getRightTooltipText(rowData)"
                  target="_blank"
                  class="no-link">{{rowData.label}}</a>
            </ng-container>
            <ng-container *ngIf="!rowData.technicalDocAvailable">
              <span [innerHTML]="rowData.label" [matTooltip]="getRightTooltipText(rowData)"></span>
            </ng-container>
            <neq-icon *ngIf="rowData.required" [matTooltip]="'label.user.rawmaterial.values.required' | translate"
                      class="flag required" svgIcon="requis"></neq-icon>
            <neq-icon *ngIf="rowData.predictor" [matTooltip]="'label.user.rawmaterial.values.predictor' | translate"
                      class="flag predictor" svgIcon="predicteur"></neq-icon>
            <neq-icon *ngIf="rowData.facultativeInput" [matTooltip]="'label.user.rawmaterial.values.facultative' | translate"
                      class="flag facultative" svgIcon="facultative"></neq-icon>
          </ng-container>

          <!-- manage the input field for the value column -->
          <ng-container *ngIf="col.field === 'value' && nutrients && getNutrientDataTable(rowData)">
            <input select-all #valueField="ngModel" nullValue [entity]="rowData"
                    (blur)="valueFilled(rowData, valueField)" [nutrimentValue]="valueField"
                    [ngClass]="getValueClass(rowData)" type="text" [pattern]="PATTERN_DECIMAL"
                    [(ngModel)]="getNutrientDataTable(rowData).value" (keyup.enter)="focusField(valueField, true)"
                    [matTooltip]="getValueTooltipMsg(rowData)"
                    (keyup.arrowdown)="focusField(valueField, true)" (keyup.arrowup)="focusField(valueField, false)"
                    [minvalue]="rowData.min" [maxvalue]="rowData.max" [disabled]="isReadOnly"/>
          </ng-container>

          <!-- Show a specific number format dépending grom the value of decimal -->
          <ng-container *ngIf="col.field === 'proposed' && getNutrientDataTable(rowData)">
            {{formatNumber(getNutrientDataTable(rowData).proposed, rowData.decimal)}}
          </ng-container>

          <ng-container *ngIf="col.field === 'registered'">
            <input [ngClass]="getRegisteredClass(rowData)" [value]="rowData.value" [disabled]="true"/>
          </ng-container>

          <ng-container *ngIf="col.field === 'diff' && nutrients && getNutrientDataTable(rowData)">
          <span *ngIf="calculateDiff(rowData, getNutrientDataTable(rowData).value); let diff"
                [class]="getDiffClass(diff)">{{diff}}</span>
          </ng-container>

          <ng-container *ngIf="col.field === 'standard' || col.field === 'min' || col.field === 'max'">
            {{formatNumber(rowData[col.field], rowData.decimal)}}
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <aside fxFlex="259px" fxLayout="column">
    <div *ngIf="showActionButton()" fxLayoutAlign="end center" class="neq-action-button">
      <button pButton
        [disabled]="!isApplyable()"
        class="neq-primeng-button primeng-flat"
        (click)="apply()"
        [matTooltip]="'msg.common.icon.rawmaterial.input.apply-values' | translate"
      >
        <neq-icon svgIcon="check"></neq-icon>
      </button>
      <button pButton
        [disabled]="!isCalculable()"
        class="neq-primeng-button primeng-flat"
        (click)="calculate()"
        [matTooltip]="'msg.common.icon.rawmaterial.input.calculation' | translate"
      >
        <neq-icon svgIcon="calcul"></neq-icon>
      </button>
      <button pButton
        [disabled]="!calculationId"
        class="neq-primeng-button primeng-flat"
        (click)="save()"
        [matTooltip]="'msg.common.icon.save' | translate"
      >
        <neq-icon svgIcon="enregistrer"></neq-icon>
      </button>
      <button pButton
        *ngIf="exportEnabled()"
        [disabled]="!canExport()"
        class="neq-primeng-button primeng-flat"
        (click)="exportRequest()"
        matTooltip="{{returnExportTooltip()}}"
      >
        <neq-icon svgIcon="exporter"></neq-icon>
      </button>
      <button pButton
        class="neq-primeng-button primeng-flat"
        [matTooltip]="traductionKeys.edit | translate"
        (click)="navigateWithState('/app/' + pathComplement +'/edit/' + productId)"
      >
        <neq-icon svgIcon="editer"></neq-icon>
      </button>
      <neq-rawmaterials-additional-actions
        [rawMaterial]="rawMaterialOrSample" [showDeleteButton]="true"
        (deleteInput)="onResetInput()">
      </neq-rawmaterials-additional-actions>
    </div>
    <div class="neq-container neq-aside-container" fxLayout="column">
      <h1>
        {{'label.user.rawmaterial.values.coherence-test' | translate }}
      </h1>
      <div fxLayoutAlign="center start">
        <neq-gauge *ngIf="coherences; else noCoherenceTemplate" [coherenceValue]="coherenceResult"
                   [tolerance]="reference.coherenceTolerance" style="height: 110px"></neq-gauge>
      </div>
      <ng-template #noCoherenceTemplate>
        <span *ngIf="!loading" class="error-strong">{{'label.user.rawmaterial.values.no-coherence' | translate }}</span>
      </ng-template>
    </div>
    <div *ngIf="checkError(); let error" class="neq-container neq-aside-container neq-info-container {{error.type}}" fxLayout="row">
      <neq-icon svgIcon="alerte" class="align-icon"></neq-icon>
      <span>{{error.message}}</span>
    </div>
    <div fxLayout="column" class="neq-container neq-aside-container">
      <h1>
        {{'label.common.summary' | translate }}
      </h1>
      <div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <calculation-status-icon (click)="showPopinOfBlockedResultsWhenReady()" (keyPress)="showPopinOfBlockedResultsWhenReady()" *ngIf="!waitingForBlockedResultsForPopin"
            class="calc-status-icon" [class.link]="canShowPopinOfBlockedResult()"
            [status]="currentCalculationStatus" [tooltipMode]="false" [inTable]="false"
          ></calculation-status-icon>
          <mat-spinner [diameter]="25" *ngIf="waitingForBlockedResultsForPopin"></mat-spinner>
        </div>
        <div style="margin-top: 5px; display: flex;"
            [class.forced-calc-status]="forcedCalcStatusForm.disabled"
            *ngIf="showForceCalcStatusToggle()"
        >
          <mat-spinner [diameter]="25" *ngIf="loadingForceStatus"></mat-spinner>
          <div *ngIf="!loadingForceStatus">
            <mat-slide-toggle [formControl]="forcedCalcStatusForm" ></mat-slide-toggle>
            {{ getToggleCalcStatusLabel() }}
            <mat-icon *ngIf="forcedCalcStatusForm.disabled && isCurrentCalcStatusBlockedBeforeCalc()"
                svgIcon="{{INFO_ICON_SVG}}" class="info-icon"
                matTooltip="{{'label.user.rawmaterial.force-status-disabled' | translate}}"></mat-icon>
          </div>
        </div>
      </div>
      <div *ngIf="entity">
        <h2>{{'label.common.owner-entity' | translate }}</h2>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <img *ngIf="entity.logo" [src]="entity.logo" alt="entity.logo">
          <span>{{entity.name}}</span>
        </div>
      </div>
      <div *ngIf="predictionModel" fxLayout="column">
        <h2>{{'label.common.prediction-model' | translate }}</h2>
        <span [matTooltip]="(predictionModel) ? predictionModel.description : ''">
          <ng-container *ngIf="predictionModel.technicalDocAvailable">
            <a (click)="getPredictionModelTechnicalDocUrl()" target="_blank">{{predictionModel.label}}</a>
          </ng-container>
          <ng-container *ngIf="!predictionModel.technicalDocAvailable">
            {{predictionModel.label}}
          </ng-container>
        </span>
      </div>

      <div *ngIf="reference" fxLayout="row" fxLayoutAlign="space-between end">
        <div fxLayout="column" fxLayoutAlign="none">
          <h2>{{'label.common.reference' | translate }}</h2>
          <span [matTooltip]="(reference) ? reference.description : ''">{{ reference.label }}</span>
          <div *ngIf="referenceAreChanged">
            {{'label.user.changed-reference' | translate }} : {{referenceAreChanged}}
          </div>
        </div>
        <button pButton *ngIf="showActionButton()"
                class="neq-primeng-button primeng-flat"
                [matTooltip]="'label.user.rawmaterial.values.change-reference' | translate"
                (click)="startModifyReference()"
        >
          <neq-icon svgIcon="editer"></neq-icon>
        </button>
      </div>
      <div *ngIf="rawMaterialOrSample?.calculationDate" fxLayout="column">
        <h2>{{'label.common.edition.events' | translate }}</h2>
        <div style="display: flex;">
          <span>
              {{
                'label.common.edition.saved.date' | translate: {
                    date: (rawMaterialOrSample.calculationDate | localDateFormat),
                    time: (rawMaterialOrSample.calculationDate | localTimeFormat),
                    user_full_name: rawMaterialOrSample.calculationBy
                  }
              }}
              {{ returnImportTypeLabel() }}
          </span>
        </div>
        <span *ngIf="rawMaterialOrSample?.exportDate" translate="label.common.edition.exported.date"
            [translateParams]="{ date: (rawMaterialOrSample.exportDate | localDateFormat),
            time: (rawMaterialOrSample.exportDate | localTimeFormat),
            user_full_name: rawMaterialOrSample.exportBy }"></span>
      </div>
    </div>
    <div class="neq-container neq-aside-container neq-note-container">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <h1>
          <neq-icon svgIcon="notes"></neq-icon>&nbsp;{{'label.common.notes' | translate }}
        </h1>
        <div *ngIf="!loading && !isReadOnly" class="neq-action-button">
          <button pButton
            [disabled]="!notes.dirty"
            class="neq-primeng-button primeng-flat"
            (click)="saveNotes()"
          >
            <neq-icon svgIcon="enregistrer"></neq-icon>
          </button>
        </div>
      </div>
      <textarea select-all matInput [formControl]="notes" style="width: 100%;"></textarea>
    </div>
  </aside>
</div>
